/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Many_Panther_CuddleInputs */

const fr_keen_many_panther_cuddle = /** @type {(inputs: Keen_Many_Panther_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmes`)
};

/**

* @param {Keen_Many_Panther_CuddleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const keen_many_panther_cuddle = /** @type {((inputs?: Keen_Many_Panther_CuddleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Many_Panther_CuddleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_keen_many_panther_cuddle(inputs)
});